"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.company.checkbox_label': 'Registrarse con empresa',
    'register.company.form_title': 'Información de la empresa',
    'register.company.section_title': 'Información de la empresa (Opcional)',
    'register.company.add_button': 'Agregar empresa',
    'register.company.data_added': 'Datos de la empresa agregados exitosamente',
    'register.company.remove_button': 'Eliminar empresa',
    'register.company.optional_help': 'Puedes agregar opcionalmente la información de tu empresa durante el registro',
    'register.company.removed': 'Datos de la empresa eliminados exitosamente',
};
